export default __webpack_public_path__ + "static/media/rotterdam.ca4eb3ab.png";